import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.list');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-community-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.list/view.scss */
/* src/app/portal.gsdcadmin.community.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityListComponent implements OnInit, OnDestroy {
    @Input() view: any;
    @ViewChild('policyDialog') policyDialog: ElementRef<HTMLDialogElement>;
    public selected: any = null;
    private previousOverflow: string | null = null;
    public communities: any[] = [];
    public loading = false;
    public failed = false;
    public canCreate = false;
    public search = '';
    public isOverview = false;
    public overviewFilter = 'all';
    public summary: any = {};
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }
    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', '/');
        this.isOverview = this.service.auth.session.role === 'admin';
        if (!this.isOverview) {
            const cid = this.service.auth.session.community_id;
            await this.router.navigateByUrl(cid ? '/admin/community/' + encodeURIComponent(cid) + '/info' : '/dashboard', {replaceUrl: true});
            return;
        }
        await this.load();
    }
    public ngOnDestroy() {
        this.policyDialog?.nativeElement.close();
        this.restoreScroll();
    }
    private restoreScroll() {
        if (this.previousOverflow !== null) document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = null;
    }
    public async openSettings(row: any) {
        if (this.selected) return;
        this.selected = row;
        await this.service.render();
        if (!this.policyDialog?.nativeElement.isConnected) return;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.policyDialog.nativeElement.showModal();
    }
    public async closeSettings() {
        this.policyDialog.nativeElement.close();
        this.restoreScroll();
        this.selected = null;
        await this.service.render();
    }
    public trapFocus(event: KeyboardEvent) {
        if (event.key !== 'Tab') return;
        const controls = Array.from(this.policyDialog.nativeElement.querySelectorAll<HTMLElement>('button:not(:disabled), input:not(:disabled)'));
        const first = controls[0], last = controls[controls.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
        }
    }
    public cancelDialog(event: Event) {
        event.preventDefault();
        this.closeSettings();
    }
    public backdropClick(event: MouseEvent) {
        const dialog = this.policyDialog.nativeElement;
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.closeSettings();
    }
    public get filtered() {
        const text = this.search.trim().toLowerCase();
        return this.communities.filter(row => [row.name,row.manager_name,...(row.leaders || [])].join(' ').toLowerCase().includes(text))
            .filter(row => !this.isOverview || this.overviewFilter === 'all' || (this.overviewFilter === 'attention' ? row.status === 'enabled' && this.missing(row).length : row.status === this.overviewFilter));
    }
    public missing(row: any) {
        const result = [];
        if (!row.has_manager) result.push('서비스 담당자');
        return result;
    }
    public async load() {
        this.loading = true;
        this.failed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call(this.isOverview ? 'load' : 'load_policies');
            if (code !== 200 || !Array.isArray(data?.rows)) throw new Error('load');
            this.communities = data.rows;
            this.canCreate = data.can_create;
            this.summary = data.summary || {};
        } catch (_) { this.failed = true; }
        finally { this.loading = false; await this.service.render(); }
    }
}

export default PortalGsdcadminCommunityListComponent;